import { statusBadge } from "../lib/format";
import type { Location } from "../lib/types";

export function StatusBadge({ loc }: { loc: Location }) {
  const s = statusBadge(loc);
  return (
    <span
      className={`inline-flex items-center gap-1.5 text-[11px] font-medium px-2 py-0.5 rounded-full border ${s.cls}`}
    >
      {s.label.startsWith("Open") && (
        <span className="pulse-dot bg-emerald-500" aria-hidden />
      )}
      {s.label}
    </span>
  );
}
